// extracted by extract-css-chunks-webpack-plugin
module.exports = {"tooltipZIndex":"3","tooltipSpacing":"10px","container":"PefUzAGdmA0b","loadingDots":"_4HImqEOJIEUo","breathe":"_0tlFbnLT-Baq"};